import classnames from 'classnames'
import PropTypes from 'prop-types'

import styles from './Icon.module.scss'

const ICON_VARIANTS = [
  'primary',
  'secondary',
  'success',
  'warning',
  'danger',
  'neutralCool',
  'neutralWarm',
  'white',
]

const ICON_VARIANT_COUNTS = [
  '50',
  '100',
  '200',
  '300',
  '400',
  '500',
  '600',
  '700',
  '800',
  '900',
]

const propTypes = {
  // maps to color
  variant: PropTypes.oneOf(ICON_VARIANTS),
  // maps to color shade
  variantCount: PropTypes.oneOf(ICON_VARIANT_COUNTS),
}

const rootProps = ({
  className,
  flipped,
  variant,
  variantCount,
  ...restProps
}) => {
  let variantStyle = ''

  if (variant && !variantCount) {
    variantStyle = styles[`icon__${variant}`]
  }
  if (variant && variantCount) {
    variantStyle = styles[`icon__${variant}-${variantCount}`]
  }

  return {
    className: classnames(
      styles.icon,
      flipped && styles.flipped,
      variantStyle,
      className
    ),
    ...restProps,
  }
}

const Icon = props => <i {...rootProps(props)} />

Icon.propTypes = propTypes
Icon.className = styles.icon

export default Icon
